import { render, staticRenderFns } from "./VisitMng.vue?vue&type=template&id=f5d98d10"
import script from "./VisitMng.vue?vue&type=script&lang=js"
export * from "./VisitMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports